// Auto-split from i18n.js — language: vi
export default {
    translation: {
        // routes & menus
        Dashboard: 'Bảng điều khiển',
        'Space Data': 'Không gian',
        'Equipment Data': 'Thiết bị',
        'Meter Data': 'Mét',
        'Tenant Data': 'Thuê',
        'Store Data': 'Cửa hàng',
        'Shopfloor Data': 'Tầng cửa hàng',
        'Combined Equipment Data': 'Thiết bị kết hợp',
        'Auxiliary System': 'Hệ thống phụ trợ',
        Microgrid: 'Lưới điện siêu nhỏ',
        'Energy Storage Power Station': 'Trạm điện',
        'Photovoltaic Power Station': 'Trạm điện',
        'Fault Alarm': 'Báo động lỗi',
        Monitoring: 'Giám sát',
        'Advanced Reporting': 'Báo cáo nâng cao',
        'Knowledge Base': 'Cơ sở tri thức',
        'Energy Category Data': 'Danh mục năng lượng',
        'Energy Item Data': 'Mục năng lượng',
        Carbon: 'Khí thải CO2',
        Cost: 'Chi phí',
        Output: 'Ra',
        Income: 'Thu nhập',
        Efficiency: 'Hiệu quả',
        Load: 'Tải',
        Statistics: 'Thống kê',
        'Batch Analysis': 'Phân tích hàng loạt',
        Saving: 'Tiết kiệmⒺ',
        Plan: 'Kế hoạchⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Theo dõi thiết bị',
        'Equipment Comparison': 'So sánh thiết bị',
        'Shopfloor Comparison': 'So sánh thiết bị',
        'Store Comparison': 'So sánh thiết bị',
        'Space Comparison': 'So sánh thiết bị',
        'Combined Equipment Comparison': 'So sánh thiết bị',
        'Tenant Comparison': 'so sánh người thuê',
        'Environment Monitor': 'Giám sát môi trường',
        'Meter Energy': 'Năng lượng đo',
        'Meter Prediction': 'Dự đoán đồng hồⒺ',
        'Virtual Meter Prediction': 'Dự đoán đồng hồ ảoⒺ',
        'Offline Meter Prediction': 'Dự đoán đồng hồ ngoại tuyếnⒺ',
        'Meter Carbon': 'Thiết bị phát thải CO2',
        'Meter Cost': 'Chi phí đồng hồ đo',
        'Meter Trend': 'Xu hướng đồng hồ đo',
        'Meter Realtime': 'Đồng hồ thời gian thực',
        'Meter Saving': 'Tiết kiệm đồng hồⒺ',
        'Meter Plan': 'Kế hoạch đồng hồⒺ',
        'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
        'Meter Batch Analysis': 'Phân tích hàng loạt đồng hồ',
        'Meter Comparison': 'So sánh đồng hồ',
        'Meter Tracking': 'Theo dõi đồng hồ đo',
        'Virtual Meter Saving': 'Tiết kiệm đồng hồ ảoⒺ',
        'Virtual Meter Plan': 'Kế hoạch đồng hồ ảoⒺ',
        'Virtual Meter Energy': 'Năng lượng đồng hồ ảo',
        'Virtual Meter Carbon': 'Khí thải CO2 ảo',
        'Virtual Meter Cost': 'Chi phí đồng hồ ảo',
        'Virtual Meter Batch Analysis': 'Phân tích hàng loạt đồng hồ ảo',
        'Virtual Meter Comparison': "So sánh công tơ ảo",
        'Offline Meter Energy': 'Đồng hồ đo năng lượng ngoại tuyến',
        'Offline Meter Carbon': 'Phát thải CO2 cho thiết bị ngoại tuyến',
        'Offline Meter Cost': 'Chi phí đồng hồ ngoại tuyến',
        'Offline Meter Batch Analysis': 'Phân tích hàng loạt đồng hồ ngoại tuyến',
        'Offline Meter Saving': 'Tiết kiệm đồng hồ ngoại tuyếnⒺ',
        'Offline Meter Plan': 'Gói đồng hồ đo ngoại tuyếnⒺ',
        'Offline Meter Input': 'Đầu vào đồng hồ ngoại tuyến',
        'Tenant Bill': 'Hóa đơn người thuê nhà',
        'Energy Flow Diagram': 'Sơ đồ dòng năng lượng',
        'Distribution System': 'Hệ thống phân phối',
        'SVG System': 'Hệ thống trực quan hóa SCADA',
        'Faults Data': 'Lỗi',
        'Space Equipments': 'Thiết bị không gian',
        'Combined Equipments': 'Thiết bị kết hợp',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Tổng số lệnh công việc',
        'Number of New Work Orders': 'Số lệnh công việc mới',
        'Number of Inprogress Work Orders': 'Số lệnh công việc đang thực hiện',
        'Number of Done Work Orders': 'Số lệnh công việc đã hoàn thành',
        'Fuel Indicator': 'Tiêu thụ nhiên liệu',
        'Charge Energy Indicator': 'Năng lượng sạc',
        'Discharge Energy Indicator': 'Năng lượng xả',
        'Charge Cost Indicator': 'Chi phí sạc',
        'Discharge Revenue Indicator': 'Doanh thu xả',
        'HVAC': 'HVAC',
        'Fire Control': 'Kiểm soát cháy',
        'Store Dashboard': 'Bảng Điều Khiển Cửa Hàng',
        'Comprehensive overview of store energy performance': 'Tổng quan hiệu suất năng lượng cửa hàng',
        'Total Stores': 'Tổng Số Cửa Hàng',
        'Total Area': 'Tổng Diện Tích',
        'Active Meters': 'Đồng Hồ Hoạt Động',
        'Active Alerts': 'Cảnh Báo Hoạt Động',
        'Total Energy Consumption': 'Tổng Tiêu Thụ Năng Lượng',
        'Carbon Emissions': 'Khí Thải Carbon',
        'Current Period': 'Kỳ Hiện Tại',
        'Energy Consumption by Category': 'Tiêu Thụ Năng Lượng Theo Danh Mục',
        'Cost Distribution by Category': 'Phân Bổ Chi Phí Theo Danh Mục',
        'Monthly Energy & Cost Trends': 'Xu Hướng Năng Lượng và Chi Phí Hàng Tháng',
        'Top 5 Energy Consuming Stores': 'Top 5 Cửa Hàng Tiêu Thụ Năng Lượng Nhiều Nhất',
        'Energy Category Details': 'Chi Tiết Danh Mục Năng Lượng',
        'Store Performance Overview': 'Tổng Quan Hiệu Suất Cửa Hàng',
        'YoY Change': 'Thay Đổi So Với Năm Trước',
        'Per m²': 'Trên m²',
        'Usage Intensity': 'Cường Độ Sử Dụng',
        'Dashboard data loaded successfully': 'Dữ liệu bảng điều khiển đã tải thành công',
        'Failed to load dashboard data': 'Không thể tải dữ liệu bảng điều khiển',
        'Store Name': 'Tên cửa hàng',
        'Store Area': 'Diện tích cửa hàng',
        'Energy Consumption': 'Tiêu thụ năng lượng',
        'Consumption': 'Tiêu thụ',
        'last period': 'kỳ trước',
        // Tenant Dashboard
        'Tenant Dashboard': 'Bảng Điều Khiển Người Thuê',
        'Comprehensive overview of tenant energy performance': 'Tổng quan toàn diện về hiệu suất năng lượng của người thuê',
        'Total Tenants': 'Tổng Số Người Thuê',
        'Tenant Performance Overview': 'Tổng Quan Hiệu Suất Người Thuê',
        'Tenant Name': 'Tên Người Thuê',
        'Tenant Area': 'Diện Tích Người Thuê',
        'Tenant Type': 'Loại Người Thuê',
        // Equipment Dashboard
        'Equipment Dashboard': 'Bảng Điều Khiển Thiết Bị',
        'Total Equipments': 'Tổng Số Thiết Bị',
        'Equipment Performance Overview': 'Tổng Quan Hiệu Suất Thiết Bị',
        'Equipment Name': 'Tên Thiết Bị',
        'Equipment Type': 'Loại Thiết Bị',
        'Total Energy': 'Tổng Năng Lượng',
        'Total Sensors': 'Tổng Số Cảm Biến',
        'Increment Rate': 'Tỷ Lệ Tăng Trưởng',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Tổng số xưởng',
        'Shopfloor Performance Overview': 'Tổng quan hiệu suất xưởng',
        'Shopfloor Name': 'Tên xưởng',
        'Shopfloor Area': 'Diện tích xưởng',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Tổng số thiết bị kết hợp',
        'Combined Equipment Performance Overview': 'Tổng quan hiệu suất thiết bị kết hợp',
        'Combined Equipment Name': 'Tên thiết bị kết hợp',
        'Associated Equipments': 'Thiết bị liên kết',

        // Dashboard
        'Welcome to QiXuan': 'Chào mừng bạn đến với QiXuan',
        'An Industry Leading Energy Management System':
            'Một hệ thống quản lý năng lượng hàng đầu trong ngành',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Tiêu thụ năm nay {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Chi phí năm nay {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Tiêu thụ tháng này {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Chi phí của tháng này {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Tiêu thụ {{CATEGORY}} {{VALUE}} {{UNIT}} cùng kỳ năm ngoái',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Chi phí {{CATEGORY}} {{VALUE}} {{UNIT}} cùng kỳ năm ngoái',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Tiêu thụ {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Chi phí {{UNIT}}',
        // Entities
        Space: 'Không gian',
        Equipment: 'Thiết bị',
        Meter: 'Mét',
        'Offline Meter': 'Đồng hồ ngoại tuyến',
        'Virtual Meter': 'Đồng hồ ảo',
        Tenant: 'Thuê',
        Store: 'Cửa hàng',
        Shopfloor: 'Tầng cửa hàng',
        'Combined Equipment': 'Thiết bị kết hợp',
        'Cost Center': 'Trung tâm chi phí',
        Name: 'Tên',
        DisplayName: 'Tên hiển thị',
        UserName: 'Tên người dùng',
        Description: 'Sự miêu tả',
        'Energy Category': 'Danh mục năng lượng',
        'Child Spaces': 'Không gian trẻ em',
        'Associated Equipment': 'Thiết bị liên quan',
        //Energy Categories
        Electricity: 'Điện',
        Water: 'Nước',
        'Natural Gas': 'Khí thiên nhiên',
        // SidePanelModal
        Settings: 'Cài đặt',
        'Set your own customized style': 'Đặt phong cách tùy chỉnh của riêng bạn',
        'Color Scheme': 'Bảng màu',
        'Choose the perfect color mode for your app': 'Chọn chế độ màu hoàn hảo cho ứng dụng của bạn',
        Light: 'Ánh sáng',
        Dark: 'Tối',
        'RTL Mode': 'Chế độ RTL',
        'Switch your language direction': 'Chuyển hướng ngôn ngữ của bạn',
        'Fluid Layout': 'Bố cục chất lỏng',
        'Toggle container layout system': 'Chuyển đổi hệ thống bố trí container',
        'Navigation Position': 'Vị trí điều hướng',
        'Vertical': 'Dọc',
        'Top': 'Đầu trang',
        'Combo': 'Kết hợp',
        'Transparent': 'Trong suốt',
        'Inverted': 'Đảo ngược',
        'Card': 'Dạng thẻ',
        'Vibrant': 'Sống động',
        'Select a suitable navigation system for your web application':
            'Chọn một hệ thống điều hướng phù hợp cho ứng dụng web của bạn',
        'Vertical Nav': 'Điều hướng dọc',
        'Top Nav': 'Điều hướng hàng đầu',
        'Vertical Navbar Style': 'Kiểu Navbar dọc',
        'Switch between styles for your vertical navbar': 'Chuyển đổi giữa các kiểu cho thanh điều hướng dọc của bạn',
        Language: 'Ngôn ngữ',
        'Switch between languages': 'Chuyển đổi giữa các ngôn ngữ',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Thích những gì bạn thấy?',
        'Get QiXuan now': 'Tải QiXuan ngay bây giờ',
        Purchase: 'Phiên bản doanh nghiệp',
        ContactInfo: 'Thong tin lien he',
        ProductWebsite: 'Website san pham',
        CompanyWebsite: 'Website cong ty',
        SalesPhone: 'So dien thoai ban hang',
        // Query Panel
        'Base Period Begins': 'Thời gian cơ sở bắt đầu',
        'Base Period Ends': 'Thời gian cơ sở kết thúc',
        'Comparison Types': 'Các loại so sánh',
        'Year-Over-Year': 'So với cùng kỳ năm ngoái',
        'Month-On-Month': 'Hàng tháng',
        'Free Comparison': 'So sánh miễn phí',
        'None Comparison': 'Không so sánh',
        'Reporting Period Begins': 'Thời gian báo cáo bắt đầu',
        'Reporting Period Ends': 'Kỳ báo cáo kết thúc',
        '(Optional)': '(Tùy chọn)',
        'Period Types': 'Các loại thời gian',
        Yearly: 'Thường niên',
        Monthly: 'Nguyệt san',
        Weekly: 'Tuần',
        Daily: 'Nhật báo',
        Hourly: 'Giờ',
        Submit: 'Trình',
        'Input Energy Category': 'Danh mục năng lượng đầu vào',
        'Output Energy Category': 'Danh mục năng lượng đầu ra',
        'Fraction Parameter': 'Tham số phân số',
        Search: 'Tìm kiếm',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'OK',
        today: 'Hôm nay',
        yesterday: 'Hôm qua',
        hours: 'Giờ',
        minutes: 'Biên bản',
        seconds: 'Giây',
        last7Days: '7 ngày qua',
        tomorrow: 'Ngày mai',
        dayAfterTomorrow: 'Ngày kia',
        next7Days: '7 ngày tới',
        'Select Date Range': 'Chọn Phạm vi ngày',
        //Card Summaries and Line Charts
        'Base Period': 'Thời gian cơ sở',
        'Reporting Period': 'Kỳ báo cáo',
        'Per Unit Area': 'Trên một đơn vị diện tích',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Mỗi đơn vị sản xuất',
        Baseline: 'Baseline',
        Actual: 'Thực tế',
        'Baseline Value - Actual Value': 'Baseline - Thực tế',
        'Average Load': 'Tải trung bình',
        'Maximum Load': 'Tải tối đa',
        'Load Factor': 'Hệ số tải',
        'Ratio of Average Load to Maximum Load': 'Tỷ lệ tải trung bình so với tải tối đa',
        'Carbon Dioxide Emissions by Energy Category': 'Phát thải carbon dioxide theo danh mục năng lượng',
        'Costs by Energy Category': 'Chi phí theo loại năng lượng',
        'Incomes by Energy Category': 'Thu nhập theo loại năng lượng',
        'Electricity Consumption by Time-Of-Use': 'Tiêu thụ điện theo thời gian sử dụng',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Điện phát thải carbon dioxide theo thời gian sử dụng',
        'Electricity Cost by Time-Of-Use': 'Chi phí điện theo thời gian sử dụng',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Tiêu thụ theo các mặt hàng năng lượng',
        'Ton of Standard Coal by Energy Category': 'Tấn than tiêu chuẩn (TCE) theo loại năng lượng',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Tấn khí thải carbon dioxide (TCO2E) theo loại năng lượng',
        'Reporting Period Consumption CATEGORY UNIT': 'Tiêu thụ kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} Tiêu thụ kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Tiêu thụ kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Tiêu thụ kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Tiêu thụ thời gian cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Tiêu thụ kỳ báo cáo {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Tiêu thụ kỳ báo cáo {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Tiêu thụ thời gian cơ sở {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Tỷ lệ không gian trẻ em theo loại năng lượng {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Tổng tỷ lệ không gian trẻ em',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Kỳ báo cáo Phát thải Carbon Dioxide {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Kỳ báo cáo Phát thải Carbon Dioxide {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Thời kỳ cơ sở Phát thải carbon Dioxide {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Chi phí kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Chi phí kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Chi phí giai đoạn cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Sản lượng kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Sản lượng kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Sản lượng kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Sản lượng kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Sản lượng giai đoạn cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Thu nhập kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Thu nhập kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Thu nhập thời kỳ cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Kỳ báo cáo Tổng thu nhập {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Kỳ báo cáo Hiệu quả tích lũy {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} Kỳ báo cáo Hiệu quả tích lũy {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Kỳ báo cáo Tích lũy Hiệu quả toàn diện {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Kỳ báo cáo Tích lũy Hiệu quả toàn diện {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Thời gian cơ sở Tích lũy Hiệu quả toàn diện {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Hiệu quả tức thời {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Hiệu quả tức thời {{UNIT}}',
        'Equipment Efficiency Indicator': 'Chỉ số hiệu suất năng lượng của thiết bị',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Hiệu quả toàn diện tức thời {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Kỳ báo cáo Hiệu quả tích lũy {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Kỳ báo cáo Hiệu quả tích lũy {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Thời gian cơ sở Hiệu quả tích lũy {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Thời gian cơ sở Hiệu quả tích lũy {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Thời gian cơ sở {{CATEGORY}} Tải tối đa {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Kỳ báo cáo {{CATEGORY}} Tải tối đa {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Kỳ báo cáo {{CATEGORY}} Tải trung bình {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Kỳ báo cáo {{CATEGORY}} Hệ số tải',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Thời gian cơ sở {{CATEGORY}} Tải trung bình {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Kỳ báo cáo {{CATEGORY}} Giá trị trung bình {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Kỳ báo cáo {{CATEGORY}} Giá trị tối đa {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Kỳ báo cáo {{CATEGORY}} Giá trị tối thiểu {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Kỳ báo cáo {{CATEGORY}} Trung bình số học {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Kỳ báo cáo {{CATEGORY}} Trung tuyến (Giá trị trung bình) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Kỳ báo cáo {{CATEGORY}} Độ lệch chuẩn mẫu {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Kỳ báo cáo {{CATEGORY}} Phương sai mẫu {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Tiết kiệm kỳ báo cáo {{CATEGORY}} (Đường cơ sở - Thực tế) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Kỳ báo cáo giảm {{CATEGORY}} (Đường cơ sở - Thực tế) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Tiết kiệm kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Tiết kiệm thời gian cơ bản {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Kỳ báo cáo Tiêu thụ đồng hồ chính {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Kỳ báo cáo Tiêu thụ đồng hồ chính {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': 'Kỳ báo cáo Tiêu thụ công tơ phụ {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Kỳ báo cáo Tiêu thụ công tơ phụ {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Chênh lệch kỳ báo cáo {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Chênh lệch phần trăm kỳ báo cáo',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Chênh lệch kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Giá trị xu hướng',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Danh sách lỗi',
        'Reporting Period Number of Fault VALUE': 'Kỳ báo cáo Số lỗi {{VALUE}}',
        'All Faults': 'Tất cả lỗi',
        'Space Faults': 'Lỗi không gian',
        'Number of All Faults': 'Số lượng tất cả các lỗi',
        'Number of Space Faults': 'Số lỗi không gian',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Tấn than tiêu chuẩn',
        'Ton of Carbon Dioxide Emissions': 'Tấn khí thải carbon dioxide',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Lượng khí thải carbon trên mỗi đơn vị tiêu thụ năng lượng',
        'Operating Characteristic Curve': 'Đường cong đặc tính làm việc',
        Tariff: 'Thuế quan',
        'Detailed Data': 'Dữ liệu chi tiết',
        'Child Spaces Data': 'Dữ liệu không gian trẻ em',
        'Associated Equipment Data': 'Dữ liệu thiết bị liên quan',
        'This Year': 'Năm nay',
        'The Same Period Last Year': 'cùng kỳ năm ngoái',
        'This Month': 'Tháng này',
        'This Day': 'Ngày này',
        Total: 'Tất cả',
        'No data found': 'Không tìm thấy dữ liệu',
        Export: 'Xuất khẩu',
        'AI Analysis': 'Phân tích AI',
        Datetime: 'Ngày giờ',
        'Time-Of-Use Type': 'Loại thời gian sử dụng',
        'Top-Peak': 'Đỉnh cao nhất',
        'On-Peak': 'Vào giờ cao điểm',
        'Mid-Peak': 'Giữa giờ cao điểm',
        'Off-Peak': 'Ngoài giờ cao điểm',
        'Deep': 'Deep-Valley',
        Percentage: 'Tỷ lệ phần trăm',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Xu hướng trong giờ cuối cùng của Điểm giá trị năng lượng',
        Circuit: 'Mạch',
        Point: 'Điểm',
        'Realtime Value': 'Giá trị thời gian thực',
        //Meter Tracking
        'Meter List': 'Danh sách đồng hồ đo',
        'Edit Meter': 'Biên tập',
        'Start Value': 'Giá trị bắt đầu',
        'End Value': 'Giá trị cuối cùng',
        'Difference Value': 'Giá trị chênh lệch',
        'Start Integrity Rate': 'Tỷ lệ toàn vẹn bắt đầu(%)',
        'End Integrity Rate': 'Tỷ lệ toàn vẹn cuối cùng(%)',
        'Full Integrity Rate': 'Tỷ lệ toàn vẹn đầy đủ(%)',
        'Start Integrity Rate Description': 'Tỷ lệ toàn vẹn dữ liệu bắt đầu: Tỷ lệ đồng hồ đã lấy thành công số liệu tiêu thụ năng lượng tại thời điểm bắt đầu trong số tất cả các đồng hồ trong khoảng thời gian thống kê',
        'End Integrity Rate Description': 'Tỷ lệ toàn vẹn dữ liệu kết thúc: Tỷ lệ đồng hồ đã lấy thành công số liệu tiêu thụ năng lượng tại thời điểm kết thúc trong số tất cả các đồng hồ trong khoảng thời gian thống kê',
        'Full Integrity Rate Description': 'Tỷ lệ toàn vẹn dữ liệu toàn diện: Tỷ lệ đồng hồ đã lấy thành công số liệu tiêu thụ năng lượng tại cả thời điểm bắt đầu và kết thúc trong số tất cả các đồng hồ trong khoảng thời gian thống kê',
        //Equipment Tracking
        'Equipment List': 'Danh sách thiết bị',
        'Edit Equipment': 'Biên tập',
        //Profile Dropdown
        Feedback: 'Phản hồi',
        'Account Settings': 'Cài đặt tài khoảntrở lại',
        Logout: 'Đăng xuất',
        //Authentication
        'Log in': 'Đăng nhập',
        'Email address': 'Địa chỉ email',
        'Phone Number': 'Số điện thoại',
        Password: 'Mật khẩu',
        CaptchaCode: 'Captcha',
        Refresh: 'Làm tươi',
        'Remember me': 'Ghi nhớ tôi',
        'Logged in as ': 'Đăng nhập với tư cách ',
        'Forgot Password?': 'Quên mật khẩu?',
        'Forgot your password?': 'Quên Mật khẩu?',
        "Enter your email and we'll send you a reset link":
            'Nhập email của bạn và chúng tôi sẽ gửi cho bạn liên kết đặt lại',
        "Enter your email and we'll send you a registration link":
            'Nhập email của bạn và chúng tôi sẽ gửi cho bạn liên kết đăng ký',
        'Reset Password': 'Đặt lại mật khẩu',
        'Thanks for using QiXuan!': 'Cảm ơn bạn đã sử dụng QiXuan!',
        'You are now successfully signed out': 'Bây giờ bạn đã đăng xuất thành công',
        'Return to Login': 'Quay lại Đăng nhập',
        'Please check your email!': 'Vui lòng kiểm tra email của bạn!',
        'An email has been sent to ': 'Một email đã được gửi đến ',
        'Please click on the included link to reset your password':
            'Vui lòng nhấp vào liên kết đi kèm để đặt lại mật khẩu của bạn',
        'Please click on the included link to register your account':
            'Vui lòng nhấp vào liên kết đi kèm để đăng ký tài khoản của bạn',
        'An email with password reset link is sent to ': 'Một email có liên kết đặt lại mật khẩu được gửi đến ',
        'Change Password': 'Thay đổi mật khẩu',
        'Old Password': 'Mật khẩu cũ',
        'New Password': 'Mật khẩu mới',
        'Confirm Password': 'Xác nhận mật khẩu',
        'Update Password': 'Cập nhật mật khẩu',
        'Password has been changed!': 'Mật khẩu đã được thay đổi!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'Mã xác minh đã được gửi đến hộp thư đến của bạn. \
  Vui lòng sao chép nó vào hộp nhập liệu bên dưới.',
        'New to QiXuan': 'Bạn mới sử dụng QiXuan',
        'Create an account': 'Tạo tài khoản',
        'EMAIL Account registration successful': '{{EMAIL}} Đăng ký tài khoản thành công',
        'Thanks for verifying your account!': 'Cảm ơn bạn đã xác minh tài khoản của bạn!',
        'Your code is': 'Mã của bạn là',
        'Send verification code': 'Gửi mã xác minh',
        'Please wait for NUMBER seconds': 'Vui lòng chờ đợi {{NUMBER}} Giây',
        'Password reset': 'Đặt lại mật khẩu',
        'Please wait for approval': 'Vui lòng chờ phê duyệt',
        //notification
        Notifications: 'Thông báo',
        'Mark all as read': 'Đánh dấu tất cả là đã đọc',
        'View all': 'Tất cả',
        'Notification New': 'MỚI',
        'Notification Earlier': 'TRƯỚC',
        'Notification List': 'Danh sách thông báo',
        'Bulk actions': 'Hành động hàng loạt',
        'Notification Subject': 'Chủ đề',
        'Notification Created Datetime': 'Ngày giờ đã tạo',
        'Notification Priority': 'Ưu tiên',
        'Notification Message': 'Thông điệp',
        'Notification Status': 'Tình trạng',
        'Notification Mark As Read': 'Đánh dấu là đã đọc',
        'Notification Mark As Acknowledged': 'Thừa nhận',
        'Notification Low': 'Thấp',
        'Notification Medium': 'Đau vừa',
        'Notification High': 'Cao',
        'Notification Critical': 'Nguy kịch',
        'Notification Unread': 'Unread',
        'Notification Read': 'Đọc',
        'Notification Acknowledged': 'Thừa nhận',
        'Notification Archive': 'Lưu trữ',
        'Notification Delete': 'Xóa',
        'Notification Apply': 'Áp dụng',
        'Notification Start Datetime': 'Ngày giờ bắt đầu',
        'Notification End Datetime': 'Ngày kết thúc',
        'Notification Update Datetime': 'Cập nhật ngày giờ',
        //Monitoring
        'Run Commands': 'Chạy lệnh',
        'Pin Code': 'Mã số bưu chính',
        'Unlock': 'Mở khóa',
        'Set Value': 'Đặt giá trị',
        'Fault Alarms': 'Báo động lỗi',
        'Instantaneous Efficiency VALUE UNIT': 'Hiệu quả tức thời {{VALUE}} {{UNIT}}',
        'Communication Online': 'Trực tuyến',
        'Communication Offline': 'Ngoại tuyến',
        'Equipment Status': 'Trạng thái thiết bị',
        'Equipment Running': 'Chạy',
        'Equipment Stopped': 'Dừng lại',
        'Show Up to': 'Hiển thị lên đến',
        All: 'Tất cả',
        'FROM - TO of TOTAL': '{{FROM}} - {{TO}} của {{TOTAL}} Thiết bị',
        //Microgrid
        'Microgrid Energy': 'Năng lượng lưới điện siêu nhỏ',
        'Microgrid Revenue': 'Doanh thu lưới điện siêu nhỏ',
        'Microgrid Carbon': 'Carbon lưới điện siêu nhỏ',
        'Photovoltaic Generation': 'Sản lượng điện mặt trời',
        'EV Charger Consumption': 'Mức tiêu thụ bộ sạc EV',
        'Load Consumption': 'Mức tiêu thụ tải',
        'Grid Buy': 'Mua từ lưới',
        'Grid Sell': 'Bán cho lưới',
        'EV Charger': 'Bộ sạc EV',
        'Heat Pump': 'Máy bơm nhiệt',
        'Photovoltaic': 'Quang điện',
        'PCS Run State': 'Trạng thái hoạt động PCS',
        'PCS Unknown': 'Không rõ',
        'PCS Initializing': 'Đang khởi tạo',
        'PCS Standby': 'Chờ',
        'PCS Shutdown': 'Tắt máy',
        'PCS Fault': 'Lỗi',
        'PCS Running': 'Chạy',
        'Battery Power': 'Năng lượng pin',
        'Photovoltaic Power': 'Công suất PV',
        'Grid Power': 'Điện lưới',
        'Load Power': 'Tải điện',
        Reporting: 'Báo cáo',
        Maintenance: 'Sửa chữa',
        'Serial Number': 'Số sê-ri',
        Address: 'Địa chỉ',
        'Postal Code': 'Mã bưu điện',
        'Rated Capacity': 'Công suất định mức',
        'Rated Power': 'Công suất định mức',
        Latitude: 'Vĩ độ',
        Longitude: 'Kinh độ',
        'Strategy Management': 'Quản lý chiến lược',
        'Charging Schedule': 'Lịch sạc',
        'Charge Start Time': 'Thời gian bắt đầu sạc',
        'Charge End Time': 'Thời gian sạc kết thúc',
        'Discharge Start Time': 'Thời gian bắt đầu xả',
        'Discharge End Time': 'Thời gian kết thúc xả',
        'Total Rated Power': 'Tổng công suất định mức',
        'Total Rated Capacity': 'Tổng công suất định mức',
        "Today's Charge": "Số tiền tính phí hôm nay",
        "Today's Discharge": "Hôm nay xuất viện",
        "Today's Generation": "Sản xuất điện ngày nay",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Tổng phí',
        'Total Discharge': 'tổng lượng xả',
        'Total Generation': 'Tổng thế hệ',
        'Total Revenue': 'Tổng doanh thu',
        'Total Photovoltaic Generation': 'Tổng sản lượng điện mặt trời',
        'Total EV Charger Consumption': 'Tổng mức tiêu thụ bộ sạc EV',
        'Total Load Consumption': 'Tổng mức tiêu thụ tải',
        'Total Grid Buy': 'Tổng mua từ lưới',
        'Total Grid Sell': 'Tổng bán cho lưới',
        'Total Efficiency': 'Tổng hiệu suất',
        'Discharge Achievement Rate': 'Tỷ lệ thành tích xả',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Xếp hạng doanh thu',
        'Efficiency Ranking': 'Xếp hạng hiệu quả',
        'Charge Ranking': 'Xếp hạng công suất sạc',
        'Discharge Ranking': 'Xếp hạng xả thải',
        'Number of Microgrids': 'Số lượng lưới điện siêu nhỏ',
        'Number of Power Stations': 'Số lượng trạm điện',
        'Microgrid List': 'Danh sách lưới điện siêu nhỏ',
        'Select Microgrid': 'Chọn lưới điện siêu nhỏ',
        'Previous Page': 'Trang trước',
        'Next Page': 'Trang tiếp theo',
        '7 Days': '7 ngày',
        'Charge UNIT': 'Thù lao {{UNIT}}',
        'Discharge UNIT': 'phóng điện {{UNIT}}',
        'Generation UNIT': 'tạo ra điện {{UNIT}}',
        'Energy Indicator': 'Năng lượng',
        'Revenue Indicator': 'Thu nhập',
        'Carbon Indicator': 'Cacbon',

        // Energy Storage Power Station
        'Battery Operating State': 'Trạng thái hoạt động của pin',
        'Battery State': 'Trạng thái pin',
        'Battery Unknown': 'Không rõ',
        'Battery Stopped': 'Đã dừng',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Lỗi', // 1
        'Battery Warning': 'Cảnh báo', // 2
        'Battery Standby': 'Phụ tùng', // 3
        'Battery Prohibit DisCharging': 'Không gỡ cài đặt', // 4
        'Battery Prohibit Charging': 'Không sạc', // 5
        'Battery Normal': 'Đặc trưng', // 6
        'Battery Charging': 'Đang sạc', // 7
        'Battery Discharging': 'Đang xả', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Giai đoạn vòng đời',
        'Use Phase': 'Giai đoạn sử dụng',
        'Commissioning Phase': 'Giai đoạn gỡ lỗi',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Giai đoạn cài đặt',
        'Device Status': 'Trạng thái thiết bị',
        'Basic Information': 'Thông tin cơ bản',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'biến tần',
        'Invertor Run State': 'Trạng thái hoạt động',
        'Invertor Unknown': 'Không rõ',
        'Invertor Initializing': 'Đang khởi tạo',
        'Invertor Standby': 'Chờ',
        'Invertor Shutdown': 'Tắt máy',
        'Invertor Fault': 'Lỗi',
        'Invertor Running': 'Chạy',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'Đã tạo Datetime',
        'File Format': 'Định dạng tệp',
        'File Size': 'Kích thước tệp',
        Uploader: 'Trình tải lên',
        //Error
        "The page you're looking for is not found": 'Không tìm thấy trang bạn đang tìm kiếm',
        "Make sure the address is correct and that the page hasn't moved. ":
            'Đảm bảo địa chỉ chính xác và trang chưa di chuyển. ',
        'If you think this is a mistake,': 'Nếu bạn nghĩ rằng đây là một sai lầm,',
        'contact us': 'Liên hệ với chúng tôi',
        'Take me home': 'Đưa tôi về nhà',
        'Whoops, something went wrong!': 'Rất tiếc, đã xảy ra sự cố!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Thử làm mới trang hoặc quay lại và thử lại hành động. ',
        'If this problem persists,': 'Nếu vấn đề này vẫn tiếp diễn,',
        'Captcha Error': 'Lỗi Captcha',
        'Confirm Password Error': 'Mật khẩu xác nhận không khớp',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Có vẻ như bạn đã nhấp vào \
liên kết đặt lại mật khẩu không hợp lệ. Vui lòng thử lại.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Có vẻ như bạn đã nhấp vào \
liên kết tài khoản đăng ký không hợp lệ. Vui lòng thử lại.',
        //Tenant Bill
        'Lease Contract Number': 'Số hợp đồng thuê',
        Download: 'Tải xuống',
        Print: 'In',
        'Payment Notice': 'Thông báo thanh toán',
        'Bill To': 'Lập hóa đơn đến',
        'Bill Number': 'Số hóa đơn',
        'Bill Date': 'Ngày lập hóa đơn',
        'Payment Due Date': 'Ngày đến hạn thanh toán',
        'Amount Payable': 'Số tiền phải trả',
        'Billing Period Start': 'Thời hạn thanh toán Bắt đầu',
        'Billing Period End': 'Kết thúc thời hạn thanh toán',
        Quantity: 'Số lượng',
        Price: 'Giá',
        Unit: 'Đơn vị',
        Amount: 'Lượng',
        Subtotal: 'Tổng phụ',
        'VAT Output Tax': 'Thuế đầu ra VAT',
        'Total Amount Payable': 'Tổng số tiền phải trả',
        'Please make sure to pay on or before the payment due date above':
            'Vui lòng đảm bảo thanh toán vào hoặc trước ngày đến hạn thanh toán ở trên',
        'Send money to the following account': 'Gửi tiền vào tài khoản sau',
        'Account Name': 'Tên tài khoản',
        'Bank Name': 'Tên ngân hàng',
        'Bank Address': 'Địa chỉ ngân hàng',
        'RMB Account': 'Tài khoản RMB',
        // button
        'Toggle Navigation': 'Chuyển đổi điều hướng',
        // working calendar
        'Working Days': 'Ngày làm việc',
        'Non Working Days': 'Ngày không làm việc',
        'Select Row': 'Vui lòng chọn Hàng dữ liệu',
        // Offline Meter Input
        'Daily Value': 'Giá trị hàng ngày',
        Date: 'Ngày',
        'Successfully Saved': 'Đã lưu thành công',
        'Previous Data Is Empty': 'Dữ liệu trước đó trống',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': 'Giá trị đồng hồ ngoại tuyến không hợp lệ',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Mối quan hệ với Virtual Power Plant',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'Bảng tổng hợp',
        SubMeter: 'Bảng phụ',
        'Power Quality': 'คุณภาพพลังงานไฟฟ้า',
        'About Power Quality': 'เกี่ยวกับคุณภาพพลังงานไฟฟ้า',
        Category: 'หมวดหมู่',
        Type: 'ประเภท',
        Limit: 'ขีดจำกัด',
        'Normal Limit': 'ขีดจำกัดปกติ',
        'Severe Limit': 'ขีดจำกัดรุนแรง',
        Compliance: 'อัตราการสอดคล้อง',
        'Worst Deviation': 'ค่าความเบี่ยงเบนสูงสุด',
        'Worst Time': 'เวลาที่เบี่ยงเบนสูงสุด',
        'Severe Exceed Count': 'จำนวนครั้งที่เกินรุนแรง',
        'Worst Unbalance': 'ความไม่สมดุลสูงสุด',
        Hz: 'เฮิรตซ์',
        voltage: 'แรงดันไฟฟ้า',
        current: 'กระแสไฟฟ้า',
        frequency: 'ความถี่',
        voltage_deviation: 'ความคลาดเคลื่อนแรงดัน',
        current_unbalance: 'ความไม่สมดุลของกระแส',
        voltage_unbalance: 'ความไม่สมดุลของแรงดัน',
        mean_deviation_pct: 'ความคลาดเคลื่อนเฉลี่ย (%)',
        p95_abs_deviation_pct: 'ความคลาดเคลื่อนสัมบูรณ์ P95 (%)',
        mean_abs_deviation_hz: 'ความคลาดเคลื่อนสัมบูรณ์เฉลี่ย (Hz)',
        p95_abs_deviation_hz: 'ความคลาดเคลื่อนสัมบูรณ์ P95 (Hz)',
        mean_unbalance_pct: 'ความไม่สมดุลเฉลี่ย (%)',
        p95_unbalance_pct: 'ความไม่สมดุล P95 (%)',
        count: 'จำนวน',
        min: 'น้อยสุด',
        max: 'มากสุด',
        mean: 'เฉลี่ย',
        std: 'ส่วนเบี่ยงเบนมาตรฐาน',
        p5: 'P5',
        p95: 'P95'
    }
};
